/** @jsxImportSource @emotion/react */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

import chargeFailStyles from './charge-fail.styles';
import { Button } from '../../../../components/button/button.component';
import circleWarning from '../../../../assets/icons/circle_warning.svg';
import { useNavigate } from 'react-router-dom';

export const ChargeFail: FC = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    return (
        <div css={chargeFailStyles.container}>
            <div css={chargeFailStyles.info}>
                <p css={chargeFailStyles.description}>
                    <img src={circleWarning} alt="circle-check" />
                    {intl.formatMessage({ id: 'paymentFailed' })}
                </p>
                <p css={chargeFailStyles.description}>
                    {intl.formatMessage({ id: 'somethingWentWrong' })}
                </p>
            </div>
            <Button text={intl.formatMessage({ id: 'tryAgain' })} onClick={() => navigate(-2)} />
        </div>
    );
};
